import React from 'react'

export const NoMatch = () => (
    <div>
          <h1>No Match</h1>  
          <p>Page doesn't exist yet</p>
    </div>
)
